<template>
    <div class="page-home">
        <SectionBanner></SectionBanner>
        <SectionInvite></SectionInvite>
        <SectionSolution></SectionSolution>
        <SectionFlow></SectionFlow>
        <SectionTec></SectionTec>
        <SectionSuccess></SectionSuccess>
    </div>
</template>

<script>
import {buildTdk} from '@config/tdk';
import SectionBanner from './sections/banner.vue';
import SectionInvite from './sections/invite.vue';
import SectionSolution from './sections/solution.vue';
import SectionFlow from './sections/flow.vue';
import SectionTec from './sections/tec.vue';
import SectionSuccess from './sections/success.vue';


export default {
    head() {
        var tdk = (buildTdk('home'));
        tdk.title = tdk.webName;
        return tdk
    },
    components: {
        SectionBanner,
        SectionInvite,
        SectionSolution,
        SectionFlow,
        SectionTec,
        SectionSuccess,
    },
    data () {
        return {
            webType:'hzc',
        };
    },
    methods: {},
    mounted () { },
};
</script>

<style lang="scss" scoped>
@import '@/assets/css/hzc.scss';

.page-home {
}
</style>
